<div
  class="ancillary-bundle-selection flex flex--column"
  [attr.data-testid]="'ancillary-bundle-selection-' + category()"
>
  <fin-bundle-info-header
    class="ms-large-b"
    [bundleName]="this.translations()?.title"
    [bundleDescription]="this.translations()?.description"
  />

  @let bundleConstituents = constituents();
  @let availability = availabilityByPax();
  @let selections = selectionsByPax();
  @for (passenger of passengers(); track passenger.id) {
    <fin-bundle-offer-card
      class="ms-large-b"
      [passenger]="passenger"
      [constituents]="bundleConstituents"
      [availability]="availability[passenger.id] ?? null"
      [selectedForPassenger]="!!selections[passenger.id]"
      (addCombo)="addCombo(passenger)"
      (removeCombo)="removeCombo(passenger)"
    />
  }
</div>
